import NeoGridContainer from "../../design/design_components/neo/layout/NeoGridContainer.base";
import NeoTitleMain from "../../design/design_components/neo/title/NeoTitleMain.base";
import NeoMessage from "../../design/design_components/neo/messages/NeoMessage.base";
import Icono from "../../design/assets/img/wfi/icons/icon-settings.svg";
import ImageError404 from "../../design/assets/img/wfi/Logo-NeoWifi-error404.png";


export default function NotFound() {
  return (
    <>
      <NeoGridContainer>
        <NeoTitleMain title="Mi Cuenta" icon={Icono} />
      </NeoGridContainer>

      <NeoMessage severity="info" text="Actualmente no cuentas con una cuenta activa de NeoWifi. Por favor, contacta a tu GM." style={{ width: "100%" }} />
      <img src={ImageError404} style={{ width: "100%", height: "auto" }} />
    </>
  );
}